import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/es/Button/Button";
import Checkbox from "@material-ui/core/es/Checkbox/Checkbox";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import Slider from "@material-ui/core/es/Slider/Slider";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import _ from "lodash";
import moment from "moment";
import React from "react";
import AlertDialog from "../components/AlertDialog";
import DateRangeSelector from "../components/DatePicker";
import MatrixView from "../components/MatrixView";
import PopupImage from "../components/PopupImage";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Util from "../util/util";


import VLScreen from "./VLScreen";

export default class ImageSearchScreen extends VLScreen {

    contentPadding = 0;

    constructor() {
        super();

        const today = moment().startOf("day").unix();
        const yesterday = moment().add(-1, "days").startOf("day").unix();

        let columns = parseInt(localStorage.getItem("mat-cols"));
        if (isNaN(columns) || columns == null || columns < 2 || columns > 8) {
            columns = 4;
        }

        this.state = {
            loaded: false,
            cameras: [],
            selectedCameras: [],
            peopleMin: 0,
            peopleMax: 5,
            peopleLimit: 10,
            vehiclesMin: 0,
            vehiclesMax: 5,
            vehicleLimit: 10,
            vehicleBodyTypes: [],
            vehicleColours: [],
            vehicleMakes: [],
            vehicleModels: [],
            selectedVehicleBodyTypes: [],
            selectedVehicleMakes: [],
            selectedVehicleModels: [],
            selectedVehicleColours: [],
            startDate: yesterday,
            endDate: today,
            images: [],
            resultsLoading: true,
            columns,
            pageCount: 1,
            currentPage: 1,
            resultCount: 0,
            viewingImage: {},
            saved_searches: [],
            saved_searches_original: [],
            viewingSavedSearches: false,
            new_search_name: "",
            new_search_push_en: false
        };
    }

    componentDidMount() {
        API.POST("imageSearch/info", {}, result => {
            Util.handleLogout(result);
            if (result.success) {
                let newState = result.result;
                newState.selectedCameras = newState.cameras.map(e => e.id);
                newState.loaded = true;
                newState.peopleMax = newState.peopleLimit;
                newState.vehiclesMax = newState.vehicleLimit;
                newState.saved_searches_original = _.cloneDeep(newState.saved_searches);
                this.setState(newState, () => {
                    this.doSearch(1);
                });
            }
        });
    }

    title = () => "Image Search";

    content() {
        return (
            <div>
                {this.renderTextAlert()}

                {this.state.viewingImage.url &&
                <PopupImage url={this.state.viewingImage.url} close={() => this.setState({viewingImage: {}})}
                            canDelete={Util.isAdmin() && !Util.isSubAccount()} deleteImage={this.deleteImage}/>}

                <AlertDialog open={this.state.viewingSavedSearches} title="Saved Searches" size="lg" positive="Save" negative="Close"
                             action={this.closedSavedSearches} content={this.savedSearchsContent}/>

                <AlertDialog open={this.state.makingNewSearch} title="Save Searche" size="lg" positive="Save" negative="Cancel"
                             action={this.doSaveSearch} content={this.saveSearchContent}/>

                <div style={{display: "flex", justifyContent: "center"}}>
                    <div style={{flex: 25}}>{this.filters()}</div>
                    <div style={{flex: 75}}>{this.results()}</div>
                </div>
            </div>
        );
    }

    filters = () => {
        return <div style={{
            boxShadow: "0 2px 8px 0 gray",
            height: "calc(100vh - 72px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch"
        }}>

            <div style={{flex: 1, overflowY: "scroll"}}>
                {this.generateSection("Camera", 0, (
                    <MultiSelectList items={this.cameraSelectList()} selected={this.state.selectedCameras}
                                     selectionChanged={selectedCameras => this.setState({selectedCameras})}/>
                ))}
                {this.generateSection("Image Date", 1, (
                    <DateRangeSelector start={this.state.startDate} end={this.state.endDate} onChange={e => {
                        this.setState({startDate: e[0], endDate: e[1]});
                    }}/>
                ))}
                {this.generateSection("People Count", 2, (
                    this.generateMinMaxSlider("people", "peopleMin", "peopleMax", "peopleLimit")
                ))}
                {this.generateSection("Vehicle Count", 3, (
                    this.generateMinMaxSlider("vehicles", "vehiclesMin", "vehiclesMax", "vehicleLimit")
                ))}
                {this.generateSection("Vehicle Types", 4, (
                    <MultiSelectList items={this.state.vehicleBodyTypes} selected={this.state.selectedVehicleBodyTypes}
                                     selectionChanged={selectedVehicleBodyTypes => this.setState({selectedVehicleBodyTypes})}/>
                ))}
                {this.generateSection("Vehicle Models", 5, (
                    <MultiSelectList items={this.vehicleModelList()} selected={this.state.selectedVehicleModels}
                                     selectionChanged={selectedVehicleModels => this.setState({selectedVehicleModels})}/>
                ))}
                {this.generateSection("Vehicle Colours", 6, (
                    <MultiSelectList items={this.state.vehicleColours} selected={this.state.selectedVehicleColours}
                                     selectionChanged={selectedVehicleColours => this.setState({selectedVehicleColours})}/>
                ))}
            </div>
            <div style={{display: "flex", margin: "16px 16px 0 16px"}}>
                <VLButton title="View Saved Searches" style={{flex: 1}} onClick={this.viewSavedSearches}/>
                <div style={{width: 16}}/>
                <VLButton title="Save this search" style={{flex: 1}} onClick={this.saveNewSearch}/>
            </div>
            <VLButton title="Search" style={{margin: 16}} onClick={this.searchClicked}/>

        </div>;
    };

    generateSection = (title, id, children) => (
        <CollapsibleSection title={title} open={this.isSectionOpen(id)} handleOpenToggle={this.sectionToggleHandler(id)}>
            <div style={{padding: 16}}>
                {children}
            </div>
        </CollapsibleSection>
    );

    generateMinMaxSlider = (name, minKey, maxKey, limitKey) => {
        const min = this.state[minKey];
        const max = this.state[maxKey];
        let helpText = `Showing images with ${min} - ${max} ${name}`;
        if (min === max) {
            helpText = `Showing images with ${min} ${name}`;
        }

        return <div style={{padding: "0 16px"}}>
            <Slider style={{marginTop: 24}}
                    value={[min, max]}
                    max={this.state[limitKey]}
                    onChange={(e, data) => {
                        this.setState({[minKey]: data[0], [maxKey]: data[1]});
                    }}
                    aria-labelledby="range-slider"
                    valueLabelDisplay="on"
            />
            <p>{helpText}</p>
        </div>;
    };

    cameraSelectList = () => {
        return this.state.cameras.map(({id, name}) => ({id, name}));
    };

    vehicleModelList = () => {
        return this.state.vehicleModels.map(e => ({id: e, name: e.replace("_", " ")}));
    };

    results = () => {
        if (this.state.resultsLoading) {
            return (
                <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "calc(100vh - 72px)"}}>
                    <CircularProgress size={100} thickness={2}/>
                </div>
            );
        }
        return (
            <div style={{display: "flex", flexDirection: "column", height: "calc(100vh - 72px)"}}>
                {this.resultsHeader()}
                <div style={{flex: 1, overflowY: "auto"}}>
                    <MatrixView images={this.getImages()} columns={this.state.columns}/>
                </div>
            </div>
        );
    };

    resultsHeader = () => {
        let previousStyle = this.state.currentPage > 1 ? {} : {background: "#AAA"};
        let nextStyle = this.state.currentPage < this.state.pageCount ? {} : {background: "#AAA"};
        return (
            <div style={{display: "flex", alignItems: "center", padding: "0 16px"}}>
                <div style={{flex: 1, justifyContent: "flex-start", display: "flex", alignItems: "center"}}>
                    <VLButton onClick={this.previousPage} style={previousStyle} title="Prev"/>
                    <p>Page {Util.commaise(this.state.currentPage)} / {Util.commaise(this.state.pageCount)}</p>
                    <VLButton onClick={this.nextPage} style={nextStyle} title="Next"/>
                </div>
                <div style={{flex: 1, justifyContent: "center"}}>
                    <h2 style={{textAlign: "center"}}>Found {Util.commaise(this.state.resultCount)} Results</h2>
                </div>
                <div style={{flex: 1, justifyContent: "flex-end", display: "flex"}}>
                    <VLButton onClick={this.zoomOut} title="-"/>
                    <p>Zoom</p>
                    <VLButton onClick={this.zoomIn} title="+"/>
                </div>
            </div>
        );
    };

    getImages = () => {
        let mapper = i => ({
            id: i.id_image,
            url: i.url,
            title: i.camera_name + " - " + moment.unix(i.date).format("D/M/YY HH:mm"),
            overlay: "",
            background: window.primary,
            onClick: () => this.setState({viewingImage: i})
        });

        return this.state.images.map(mapper);
    };

    isSectionOpen = (id) => this.state["openSection" + id];

    sectionToggleHandler = (id) => open => this.setState({["openSection" + id]: open});

    searchClicked = () => {
        this.setState({currentPage: 1});
        this.doSearch(1);
    };

    saveNewSearch = () => {
        this.setState({makingNewSearch: true});
    };

    saveSearchContent = () => {
        return <div>
            <input className="vl-input" name="new_search_name" value={this.state.new_search_name} onChange={this.handleInputChange} placeholder="Search Name"/>
        </div>;
    };

    doSaveSearch = doSave => {
        if (doSave) {
            this.doSearch(1, true, this.state.new_search_name, this.state.new_search_push_en);
        }
        this.setState({new_search_name: "", makingNewSearch: false});
    };

    viewSavedSearches = () => {
        this.setState({viewingSavedSearches: true});
    };

    closedSavedSearches = doSave => {
        this.setState({viewingSavedSearches: false});
        console.log(doSave);
        console.log("Saving? " + (doSave ? "YEs" : "no"));
        if (doSave) {
            let data = {
                saved_searches: JSON.stringify(this.state.saved_searches.map(e => {
                    const f = _.cloneDeep(e);
                    f.push_en = f.push_en ? 1 : 0;
                    return f;
                }))
            };
            this.setState({saved_searches_original: this.state.saved_searches});
            API.POST("imageSearch/editSearches", data, result => {

            });
        } else {
            this.setState({saved_searches: this.state.saved_searches_original});
        }
    };

    savedSearchsContent = () => {
        let searches = this.state.saved_searches;
        let rows = searches.map((e, i) => {
            if (e.deleted) return null;
            let vehicleColours = e.vehicle_colours.join(", ") || "Unfiltered";
            let vehicleBodyTypes = e.vehicle_body_types.join(", ") || "Unfiltered";
            let vehicleModels = e.vehicle_models.join(", ") || "Unfiltered";

            let nameChange = e => {
                let {saved_searches} = this.state;
                saved_searches[i].name = e.target.value;
                this.setState({saved_searches});
            };

            let pushChange = e => {
                let {saved_searches} = this.state;
                saved_searches[i].push_en = e.target.checked;
                this.setState({saved_searches});
            };

            let doSearch = () => {
                this.setState({
                    selectedCameras: e.cameras,
                    peopleMin: e.people_min,
                    peopleMax: e.people_max,
                    vehiclesMin: e.vehicles_min,
                    vehiclesMax: e.vehicles_max,
                    selectedVehicleBodyTypes: e.vehicle_body_types,
                    selectedVehicleModels: e.vehicle_models,
                    selectedVehicleColours: e.vehicle_colours,
                    currentPage: 1,
                    viewingSavedSearches: false
                }, () => this.doSearch(1));
            };

            let doDelete = () => {
                let {saved_searches} = this.state;
                saved_searches[i].deleted = true;
                this.setState({saved_searches});
            };

            return (
                <tr>
                    <td><input value={e.name} className="vl-input" placeholder="Search Name" onChange={nameChange}/></td>
                    <td><Checkbox checked={e.push_en} onChange={pushChange}/></td>
                    <td>
                        <p>{e.cameras.length} cameras</p>
                        <p>{e.people_min} - {e.people_max} people</p>
                        <p>{e.vehicles_min} - {e.vehicles_max} vehicles</p>
                    </td>
                    <td>
                        <p>Vehicle Colours: {vehicleColours}</p>
                        <p>Vehicle Types: {vehicleBodyTypes}</p>
                        <p>Vehicle Models: {vehicleModels}</p>
                    </td>
                    <td>
                        <VLButton onClick={doSearch} title="Search"/>
                        <br/>
                        <br/>
                        <VLButton style={{background: "red"}} onClick={doDelete} disabled={true} title="Delete"/>
                    </td>
                </tr>
            );
        });

        return (
            <table className="w3-table w3-table-all">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Push Enabled</th>
                    <th/>
                    <th>Parameters</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </table>
        );
    };

    doSearch = (page, doSave, saveName, pushEnabled) => {
        let data = this.filterState(["startDate", "endDate", "selectedCameras", "peopleMin", "peopleMax", "vehiclesMin", "vehiclesMax", "selectedVehicleBodyTypes", "selectedVehicleModels", "selectedVehicleMakes", "selectedVehicleColours"]);
        data.endDate += 24 * 3600;//end date should be days end
        data.selectedCameras = JSON.stringify(data.selectedCameras);
        data.selectedVehicleBodyTypes = JSON.stringify(data.selectedVehicleBodyTypes);
        data.selectedVehicleModels = JSON.stringify(data.selectedVehicleModels);
        data.selectedVehicleMakes = JSON.stringify(data.selectedVehicleMakes);
        data.selectedVehicleColours = JSON.stringify(data.selectedVehicleColours);
        data.page = page;

        if (doSave) {
            data.save_search = true;
            data.search_name = saveName;
            data.push_en = pushEnabled ? 1 : 0;
        }

        console.log(data);
        this.setState({resultsLoading: true});
        API.POST("imageSearch/search", data, result => {
            this.setState(result.result);
            this.setState({resultsLoading: false});
        });
    };

    previousPage = () => {
        const current = this.state.currentPage;
        if (current > 1) {
            this.setState({currentPage: current - 1});
            this.doSearch(current - 1);
        }
    };

    nextPage = () => {
        const current = this.state.currentPage;
        if (current < this.state.pageCount) {
            this.setState({currentPage: current + 1});
            this.doSearch(current + 1);
        }
    };

    zoomOut = () => {
        let columns = Math.min(this.state.columns + 1, 8);
        this.setState({columns});
        localStorage.setItem("mat-cols", columns);
    };

    zoomIn = () => {
        let columns = Math.max(this.state.columns - 1, 2);
        this.setState({columns});
        localStorage.setItem("mat-cols", columns);
    };

    deleteImage = () => {
        const i = this.state.viewingImage;
        const data = {
            time: i.date,
            camera_id: i.camera_id
        };
        if (window.confirm("Are you sure you want to delete this image?")) {
            API.POST("systems/deleteImage", data, result => {
                if (result.success) {
                    this.setState({viewingImage: {}});
                    this.doSearch(this.state.currentPage);
                } else {
                    this.basicAlert(result.error);
                }
            });
        }
    };

}

const CollapsibleSection = ({title, open, handleOpenToggle, children}) => {
    const icon = open ? "keyboard_arrow_up" : "keyboard_arrow_down";
    const onClick = () => handleOpenToggle(!open);
    const header = (
        <div style={{
            display: "flex",
            alignItems: "center",
            background: "#EEE",
            borderBottom: "1px solid #AAA",
            padding: "12px"
        }} className="noselect hoverable" onClick={onClick}>
            <p style={{color: "#000", fontSize: 17, fontWeight: 600, flex: 1}}>{title}</p>
            <i className="material-icons">{icon}</i>
        </div>
    );

    return open ? [header, children] : header;
};

const MultiSelectList = ({items, selected, selectionChanged}) => {
    const handleChange = event => {
        let name = event.target.name;
        let checked = event.target.checked;
        if (checked) {
            const newSelection = [...selected, name];
            selectionChanged(newSelection);
        } else {
            const newSelection = selected.filter(e => e !== name);
            selectionChanged(newSelection);
        }
    };

    const selectAll = () => selectionChanged(items.map(e => {
        return e.id || e;
    }));
    const selectNone = () => selectionChanged([]);

    const checks = items.map(e => {
        if (e.id == null) {
            e = {name: e, id: e};
        }
        return <div style={{display: "flex"}}>
            <Checkbox key={e.id} name={e.id} onChange={handleChange} checked={selected.indexOf(e.id) !== -1}/>
            <p>{e.name}</p>
        </div>;
    });

    const header = (
        <div style={{display: "flex", justifyContent: "space-between"}}>
            <Button color="primary" onClick={selectAll}>Select All</Button>
            <Button color="primary" onClick={selectNone}>Select None</Button>
        </div>
    );

    return (
        <>
            {header}
            {checks}
        </>
    );
};